import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AuthenticationService } from '../authentication.service';
import { Role } from './model/roles';
import { Permission } from './model/permissions';
import { RolePermissions } from './model/role-permissions';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsService {
  private permissions = signal<Permission[]>([]);
  private permissionsObserveable = toObservable(this.permissions);
  public currentRoles = signal<Role[]>([]);
  private readonly authService = inject(AuthenticationService);

  constructor() {
    this.authService.getOIDCUser().subscribe(x => this.onAuthChanged(x));
  }

  private onAuthChanged(info: any) {
    info = info?.info;

    this.permissions.set([]);

    if (!info) return;

    const roles = Object.keys(info['urn:zitadel:iam:org:project:roles']);
    const permissions = roles.flatMap(
      x => RolePermissions[x as keyof typeof RolePermissions] ?? []
    );

    this.currentRoles.set(roles as Role[]);
    this.permissions.set(permissions);
  }

  public hasPermission(permission: Permission | Permission[]) {
    const cperms = this.permissions();
    if (Array.isArray(permission)) {
      return cperms.filter(x => permission.includes(x)).length === cperms.length;
    } else {
      return cperms.includes(permission);
    }
  }

  public watchPermission(permission: Permission | Permission[]) {
    return this.permissionsObserveable.pipe(map(() => this.hasPermission(permission)));
  }
}
